var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.875 22.875C67.875 22.625 68 22.375 68 22C68 14.375 61.625 8 54 8C52.5 8 51.125 8.375 49.875 8.75C46 3.5 39.875 0 33 0C21.25 0 11.875 9.5 12 21.125C5 23.625 0 30.25 0 38C0 48 8 56 18 56H63C72.375 56 80 48.5 80 39C80 31.375 74.875 25 67.875 22.875ZM63 50H18C11.375 50 6 44.625 6 38C6 33 9.125 28.5 14 26.875L18 25.375C18 20.5 18 21.25 18 20.75C18.125 12.625 24.75 6 33 6C37.75 6 42.125 8.375 45 12.25L47.5 15.75L51.625 14.5C57.75 12.625 62.125 17.625 61.875 22.5L61.625 27.25L66.125 28.625C70.75 30 74 34.25 74 39C74 45.125 69 50 63 50ZM42 17.875C41.625 17.625 41.375 17.5 41 17.25C40.25 17 39.375 17 38.625 17.25C38.375 17.5 38.125 17.625 37.875 17.875L26.875 28.875C25.625 30.125 25.625 32 26.875 33.125C28 34.375 29.875 34.375 31 33.125L37 27.25V43C37 44.75 38.25 46 40 46C41.625 46 43 44.75 43 43V27.25L48.875 33.125C49.375 33.75 50.125 34 51 34C51.75 34 52.5 33.75 53 33.125C54.25 32 54.25 30.125 53 29L42 17.875Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.08494e19c8964ade82f45ed261d44b0c.svg";
export { ForwardRef as ReactComponent };